import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, switchMap, take } from 'rxjs/operators';
import { TvfScreeningService } from '../../../services/tvf-screening.service';
import { ScreeningState } from '../../../../store/screening/screening.state';
import { MatDialog } from '@angular/material/dialog';
import { TvfRequestsService } from '../../../services/tvf-requests.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TagPrintService } from '../../../services/tag-print/tag-print.service';
import { EMPTY } from 'rxjs';
import { EvidencesModalComponent, RejectModalQcComponent } from '../../../../shared/components';
import { QualityControlService } from '../../services/quality-control/quality-control.service';

@Component({
  selector: 'app-approval-rejection',
  templateUrl: './approval-rejection.component.html',
  styleUrls: ['./approval-rejection.component.sass'],
  providers: [TvfScreeningService],
})
export class ApprovalRejectionComponent implements OnInit {
  idTrade: string;
  tradeInfo = {
    divergenceResult: '',
    classification: '',
    divergenceList: [],
    fullSummaryList: [],
    destination: '',
    evaluationDiscrepancy: 0,
    warningModelDiverge: false,
    isReappraisal: false,
  };
  existsDivergences: boolean = false;
  isFinished: boolean = false;

  constructor(
    private _store: Store,
    private _dialog: MatDialog,
    private _screeningService: TvfScreeningService,
    private _requestsService: TvfRequestsService,
    private _toastrService: ToastrService,
    private _router: Router,
    private tagPrintService: TagPrintService,
    private _qualityControlService: QualityControlService
  ) {}

  ngOnInit(): void {
    const evaluationStep = sessionStorage.getItem('evaluation');
    this.tradeInfo.isReappraisal = evaluationStep !== '1';
    const { idTrade } = this._store.selectSnapshot(ScreeningState);
    this.idTrade = idTrade;

    this._screeningService
      .verifyImei(this.idTrade)
      .pipe(
        map((res: any) => !!res.hasImeiBiped),
        switchMap((hasImeiBiped: boolean) => {
          if (!hasImeiBiped) {
            this._toastrService.error('IMEI da Triagem Ausente');
            this._router.navigate(['/tvf/triagem/passo/imei']);
            return EMPTY;
          }
        })
      )
      .subscribe();

    if (this.idTrade) {
      this.getScreeningResult(this.idTrade);
    }
  }

  getScreeningResult(idTrade: string) {
    this._screeningService
      .getScreeningResult(idTrade)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.existsDivergences = res.questionDivergence;
          this.tradeInfo.evaluationDiscrepancy = res.evaluationDiscrepancy;
          this.tradeInfo.warningModelDiverge = res.warningModelDiverge;
          this.tradeInfo.divergenceResult =
            res.evaluationDiscrepancy === -1
              ? 'Com divergência negativa'
              : res.evaluationDiscrepancy === 0
                ? 'Sem Divergências'
                : 'Com divergência positiva';
          this.tradeInfo.classification = res.classification;
          this.tradeInfo.destination = res.destination;
          this.tradeInfo.fullSummaryList = res.questions.map((q) => ({
            question: q.question,
            answerN1: q.answerSeller || 'N/A',
            answerTriagem: q.answerInternal,
            reasonInternal: q.reasonInternal,
          }));

          this.tradeInfo.divergenceList = this.tradeInfo.fullSummaryList.filter(
            (item: any) => item.answerN1 !== item.answerTriagem
          );
        },
        error: (err) => console.error('Erro ao carregar triagem real:', err),
      });
  }

  disapprove() {
    const dialogRef = this._dialog.open(RejectModalQcComponent, {
      width: '800px',
      data: {
        classification: this.tradeInfo.classification,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const reasonString = result.map((i: string) => i).join(', ');
        this._qualityControlService.disapprove(this.idTrade, reasonString).subscribe({
          next: () => {
            this._toastrService.success('Trade reprovado no controle de qualidade com sucesso.');
            this._router.navigate(['tvf/controle-qualidade']);
          },
          error: (err) => {
            this._toastrService.error('Erro ao reprovar controle de qualidade.');
            console.error(err);
          },
        });
      }
    });
  }

  async approve() {
    this._qualityControlService.approve(this.idTrade).subscribe({
      next: async () => {
        const tradeTagInfo = await this._requestsService
          .getTradeTagInformations(this.idTrade)
          .toPromise();

        this.tagPrintService.print({
          ...tradeTagInfo,
          warningModelDiverge: this.tradeInfo.warningModelDiverge,
        });

        this.isFinished = true;
        this._toastrService.success('Trade aprovado no controle de qualidade com sucesso.');
      },
      error: (err) => {
        this._toastrService.error('Erro ao aprovar trade no controle de qualidade.');
        console.error(err);
      },
    });
  }

  openEvidenceImages() {
    this._dialog.open(EvidencesModalComponent, {
      width: '1000px',
      data: { idTrade: this.idTrade },
      panelClass: 'custom-modal-container',
    });
  }

  backToOverview() {
    this._router.navigate(['tvf/controle-qualidade']);
  }

  async printTag(): Promise<void> {
    const tradeTagInfo = await this._requestsService
      .getTradeTagInformations(this.idTrade)
      .toPromise();

    this.tagPrintService.print({
      ...tradeTagInfo,
      warningModelDiverge: this.tradeInfo.warningModelDiverge,
    });
  }
}
